module.exports = __webpack_public_path__ + "media/images/flags/32/South-Ossetia-7757ce5a7d5c32ceeaf9674524c8e855.png";